import { QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider, notification } from "antd";
import { useEffect } from "react";
import { DayjsConfig } from "../lib/config/dayjs";
import { queryClient } from "../lib/config/reactQuery";
import { setNotificationInstance } from "../lib/utils/notificationInstance";

export const Providers = ({ children }) => {
  const [notificationApi, notificationHolder] = notification.useNotification();

  DayjsConfig();

  const theme = {
    token: {
      fontFamily: "var(--font-roboto)",
      fontSize: 16,
      colorPrimary: "#0072cb",
      colorPrimaryActive: "#42b4e7",
      colorPrimaryBorder: "#0072cb",
      colorPrimaryHover: "#42b4e7",
      colorLinkActive: "#42b4e7",
      colorLinkHover: "#42b4e7",
      screenXSMax: 639,
      screenSMMin: 640,
      screenSM: 640,
      screenMDMax: 1023,
      screenLGMin: 1024,
      screenLG: 1024,
      screenLGMax: 1279,
      screenXLMin: 1280,
      screenXL: 1280,
      screenXLMax: 1535,
      screenXXLMin: 1536,
      screenXXL: 1536,
    },
  };

  useEffect(() => {
    setNotificationInstance(notificationApi);
  }, [notificationApi]);

  return (
    <ConfigProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <main role="main" id="__main" className="font-roboto">
          {notificationHolder} {children}
        </main>
      </QueryClientProvider>
    </ConfigProvider>
  );
};
